import styled from 'styled-components'

export default styled.div`
  font-family: 'ABChanel PB Regular S', Arial, sans-serif;
  background-color: black;
  color: white;
  display: inline-block;
  padding: 3px 8px;
  font-size: 7px;
`



// WEBPACK FOOTER //
// ./src/styles/ProductStateLabel.js